import { useState, useLayoutEffect, useMemo, useEffect, useRef } from "react";
import "./ProfileNav.css";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import LogoutNotif from "../logoutnotif/LogoutNotif";
import FallbackImg from "../FallbackImg";
import { ACCESS_KEYS } from "../../constants";
import { hasAccess } from "../../utils/Permission";
import { useContext } from "react";
import { TotalAmountContext } from "../../contexts/TotalAmountContext";
const ProfileNav = () => {
  const { user } = useSelector((state) => state.auth);
  const myOrderTab = useSelector((state) => state.myOrderTab);
  const [openIndex, setOpenIndex] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [showLogout, setShowLogout] = useState(false);
  // const [totalOverdue, setTotalOverdue] = useState(0);
  const { unsuccessfulTotal, overdueTotal } = useContext(TotalAmountContext);
  const sub_role = useSelector((state) => state.auth.sub_role) || [];
  const is_subuser =
    useSelector((state) => state.auth.user?.is_subuser) || false;

  const hasCredit = user?.has_term === true;
  const hasRefund = user?.has_cbd === true;

  const canViewProfile =
    !is_subuser || hasAccess(sub_role, ACCESS_KEYS.MY_PROFILE);
  const canViewOrder = !is_subuser || hasAccess(sub_role, ACCESS_KEYS.MY_ORDER);
  const canViewRepair =
    !is_subuser || hasAccess(sub_role, ACCESS_KEYS.MY_REPAIR);
  const canViewInvoice =
    !is_subuser || hasAccess(sub_role, ACCESS_KEYS.MY_INVOICE);
  const canViewPayment =
    !is_subuser || hasAccess(sub_role, ACCESS_KEYS.MY_PAYMENT);
  const canViewCredit = !is_subuser || hasAccess(sub_role, ACCESS_KEYS.MY_CN);
  const canViewDebit = !is_subuser || hasAccess(sub_role, ACCESS_KEYS.MY_DN);
  const canViewContra =
    !is_subuser || hasAccess(sub_role, ACCESS_KEYS.MY_CONTRA);
  const canViewRefund = !is_subuser || hasAccess(sub_role, ACCESS_KEYS.MY_RF);
  const canViewDocument =
    !is_subuser || hasAccess(sub_role, ACCESS_KEYS.DOCUMENT);

  // wrap profoption in useMemo to avoid re-created on every render
  const profoption = useMemo(() => {
    const params = new URLSearchParams(location.search);
    // console.log(sub_role); // 应为 [{ status: "purchaser", action: ["all"] }]
    // console.log(canViewOrder);
    return [
      // {
      //   title: "MY PROFILE",
      //   disabled: !canViewProfile,
      //   options: [
      //     { label: "My Account", path: "/myaccount" },
      //     { label: "Company Info", path: "/companyinfo" },
      //     {
      //       label: "Branch Management",
      //       path: "/branchmanage",
      //       //disabled: !is_subuser && isAdmin(sub_role)
      //     },
      //     {
      //       label: "User Management",
      //       path: "/usermanage",
      //       //disabled:!is_subuser && isAdmin(sub_role)
      //     },
      //     {
      //       label: "Payment Management",
      //       path: "/paymentmanage",
      //       //disabled:!is_subuser && isAdmin(sub_role)
      //     },
      //   ],
      // },
      {
        title: "MY ORDER",
        disabled: !canViewOrder,
        options: [
          {
            label: "All",
            path: "/allorder?type=all&page=1",
          },
          {
            label: "New Order",
            path: "/allorder?type=neworder&page=1",
          },
          {
            label: "Processing",
            path: "/allorder?type=processing&page=1",
          },
          {
            label: "Shipping",
            path: "/allorder?type=toship&page=1",
          },
          {
            label: "Received",
            path: "/allorder?type=toreceive&page=1",
          },
          {
            label: "Cancelled",
            path: "/allorder?type=cancelled&page=1",
          },
        ],
      },
      // {
      //   title: "MY REPAIR",
      //   disabled: !canViewRepair,
      //   options: [
      //     { label: "All", path: "/allrepair?status=all&page=1" },
      //     { label: "New", path: "/allrepair?status=new&page=1" },
      //     { label: "Collected", path: "/allrepair?status=collected&page=1" },
      //     { label: "Repairing", path: "/allrepair?status=repairing&page=1" },
      //     { label: "Shipping", path: "/allrepair?status=shipping&page=1" },
      //     { label: "Received", path: "/allrepair?status=received&page=1" },
      //     { label: "Refund", path: "/allrepair?status=refund&page=1" },
      //     { label: "Cancelled", path: "/allrepair?status=cancelled&page=1" },
      //   ],
      // },
      // {
      //   title: "MY INVOICE",
      //   disabled: !canViewInvoice,
      //   options: [
      //     {
      //       label: "All",
      //       path: "/myinvoice?tab=mybill&page=1&type=all",
      //     },
      //     {
      //       label: "Outstanding",
      //       path: "/myinvoice?tab=mybill&page=1&type=outstanding",
      //     },
      //     {
      //       label: "Overdue",
      //       path: "/myinvoice?tab=mybill&page=1&type=overduebill",
      //     },
      //     {
      //       label: "Due",
      //       path: "/myinvoice?tab=mybill&page=1&type=duebill",
      //     },
      //     {
      //       label: "Upcoming",
      //       path: "/myinvoice?tab=mybill&page=1&type=upcomingbill",
      //     },
      //     {
      //       label: "Paid",
      //       path: "/myinvoice?tab=mybill&page=1&type=billed",
      //     },
      //   ],
      // },
      // {
      //   title: "MY PAYMENT",
      //   disabled: !canViewPayment,
      //   options: [
      //     {
      //       label: "All",
      //       path: `/mypaymenthistory?tab=${myOrderTab}&type=all&page=1`,
      //     },
      //     {
      //       label: "To Pay",
      //       path: `/mypaymenthistory?tab=${myOrderTab}&type=to_pay&page=1`,
      //     },
      //     {
      //       label: "Processing",
      //       path: `/mypaymenthistory?tab=${myOrderTab}&type=processing&page=1`,
      //     },
      //     {
      //       label: "Unsuccessful",
      //       path: `/mypaymenthistory?tab=${myOrderTab}&type=unsuccessful&page=1`,
      //     },
      //     {
      //       label: "Cancelled",
      //       path: `/mypaymenthistory?tab=${myOrderTab}&type=cancelled&page=1`,
      //     },
      //     {
      //       label: "Paid",
      //       path: `/mypaymenthistory?tab=${myOrderTab}&type=paid&page=1`,
      //     },
      //   ],
      // },
      // hasCredit && {
      //   title: "MY CREDIT",
      //   disabled: !canViewCredit,
      //   options: [
      //     {
      //       label: "All",
      //       path: "/mycredit?tab=all&page=1",
      //     },
      //     {
      //       label: "Applied",
      //       path: "/mycredit?tab=used&page=1",
      //     },
      //     {
      //       label: "Unapplied",
      //       path: "/mycredit?tab=available&page=1",
      //     },
      //   ],
      // },
      // {
      //   title: "MY DEBIT",
      //   disabled: !canViewInvoice,
      //   options: [
      //     {
      //       label: "All",
      //       path: "/mydebit?tab=mybill&page=1&type=all",
      //     },
      //     {
      //       label: "Outstanding",
      //       path: "/mydebit?tab=mybill&page=1&type=outstanding",
      //     },
      //     {
      //       label: "Overdue",
      //       path: "/mydebit?tab=mybill&page=1&type=overduebill",
      //     },
      //     {
      //       label: "Due",
      //       path: "/mydebit?tab=mybill&page=1&type=duebill",
      //     },
      //     {
      //       label: "Upcoming",
      //       path: "/mydebit?tab=mybill&page=1&type=upcomingbill",
      //     },
      //     {
      //       label: "Paid",
      //       path: "/mydebit?tab=mybill&page=1&type=billed",
      //     },
      //   ],
      // },
      // {
      //   title: "MY CONTRA",
      //   disabled: !canViewInvoice,
      //   path: "/mycontra",
      // },
      // hasRefund && {
      //   title: "MY REFUND",
      //   disabled: !canViewRefund,
      //   options: [
      //     {
      //       label: "All",
      //       path: "/refundreturn?status=all&page=1",
      //     },
      //     {
      //       label: "Processing",
      //       path: "/refundreturn?status=processing&page=1",
      //     },
      //     { label: "Cancelled", path: "/refundreturn?status=cancelled&page=1" },
      //     { label: "Done", path: "/refundreturn?status=done&page=1" },
      //   ],
      // },
      // {
      //   title: "MY DOCUMENT",
      //   disabled: !canViewDocument,
      //   options: [
      //     {
      //       label: "Sales Order",
      //       path: "/alldocument?status=salesorder&page=1",
      //     },
      //     {
      //       label: "Delivery Order",
      //       path: "/alldocument?status=deliveryorder&page=1",
      //     },
      //     { label: "Invoice", path: "/alldocument?status=invoice&page=1" },
      //     { label: "Refund", path: "/alldocument?status=refund&page=1" },
      //     { label: "Statement", path: "/alldocument?status=statement&page=1" },
      //     {
      //       label: "Official Receipt",
      //       path: "/alldocument?status=officialreceipt&page=1",
      //     },
      //   ],
      // },
      // {
      //   title: "MY NOTIFICATION",
      //   path: "/mynotification",
      // },
      {
        title: "LOGOUT",
      },
    ];
  }, [location.search, myOrderTab, is_subuser, sub_role]);

  const formatCurrency = (value) => {
    return parseFloat(value).toLocaleString("en-MY", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  // Helper to compare search params, ignoring 'page'
  function isParamsMatch(a, b, keys) {
    for (const key of keys) {
      if (a.get(key) !== b.get(key)) return false;
    }
    return true;
  }

  // open the title if the current path matches any of its options
  useLayoutEffect(() => {
    // let foundIndex = profoption.findIndex(
    //   (opt) =>
    //     opt.options &&
    //     opt.options.some((o) => {
    //       const url = new URL(o.path, window.location.origin);
    //       return (
    //         url.pathname === location.pathname && url.search === location.search
    //       );
    //     })
    // );

    let foundIndex = profoption.findIndex(
      (opt) =>
        opt.options &&
        opt.options.some((o) => {
          const url = new URL(o.path, window.location.origin);
          if (url.pathname !== location.pathname) return false;
          const urlParams = new URLSearchParams(url.search);
          const locParams = new URLSearchParams(location.search);

          // Get all keys except 'page'
          const keys = Array.from(urlParams.keys()).filter((k) => k !== "page");
          return isParamsMatch(urlParams, locParams, keys);
        }),
    );

    // Handle all /orderdetail/:id?type=xxx cases for MY ORDER
    if (foundIndex === -1) {
      const orderTypes = [
        "all",
        "topay",
        "neworder",
        "processing",
        "toship",
        "toreceive",
        "cancelled",
        "to_pay",
        "unsuccessful",
        "paid",
      ];
      const params = new URLSearchParams(location.search);

      // If /orderdetail and has mph param, open MY PAYMENT
      if (
        location.pathname.startsWith("/orderdetail") &&
        params.has("mph") &&
        orderTypes.includes(params.get("type"))
      ) {
        foundIndex = profoption.findIndex((opt) => opt.title === "MY PAYMENT");
      }
      // If /orderdetail and no mph param, open MY ORDER
      else if (
        location.pathname.startsWith("/orderdetail") &&
        orderTypes.includes(params.get("type"))
      ) {
        foundIndex = profoption.findIndex((opt) => opt.title === "MY ORDER");
      }
    }

    // Handle all /repairdetail/:id?status=xxx cases for MY REPAIR
    if (foundIndex === -1) {
      const statusTypes = [
        "all",
        "new",
        "collected",
        "repairing",
        "shipping",
        "received",
        "refund",
        "cancelled",
      ];
      const params = new URLSearchParams(location.search);
      if (
        location.pathname.startsWith("/repairdetail") &&
        statusTypes.includes(params.get("status"))
      ) {
        foundIndex = profoption.findIndex((opt) => opt.title === "MY REPAIR");
      }
    }

    // Handle all /invoicedetail/:id?type=xxx cases for MY INVOICE
    if (foundIndex === -1) {
      const tabTypes = [
        "all",
        "outstanding",
        "overduebill",
        "duebill",
        "upcomingbill",
        "billed",
      ];
      const params = new URLSearchParams(location.search);
      if (
        location.pathname.startsWith("/invoicedetail") &&
        tabTypes.includes(params.get("type"))
      ) {
        foundIndex = profoption.findIndex((opt) => opt.title === "MY INVOICE");
      }
    }

    // Handle all /transdtlpayment/:id?type=xxx cases for MY PAYMENT
    if (foundIndex === -1) {
      const tabTypes = [
        "all",
        "to_pay",
        "processing",
        "unsuccessful",
        "cancelled",
        "paid",
      ];
      const params = new URLSearchParams(location.search);
      if (
        location.pathname.startsWith("/transdtlpayment") &&
        tabTypes.includes(params.get("type"))
      ) {
        foundIndex = profoption.findIndex((opt) => opt.title === "MY PAYMENT");
      }
    }

    // Handle all /creditdetail/:id?tab=xxx cases for MY CREDIT
    if (foundIndex === -1) {
      const tabTypes = ["all", "used", "available"];
      const params = new URLSearchParams(location.search);
      if (
        location.pathname.startsWith("/creditdetail") &&
        tabTypes.includes(params.get("tab"))
      ) {
        foundIndex = profoption.findIndex((opt) => opt.title === "MY CREDIT");
      }
    }

    // Handle all /debitdetail/:id?type=xxx cases for MY DEBIT
    if (foundIndex === -1) {
      const tabTypes = [
        "all",
        "outstanding",
        "overduebill",
        "duebill",
        "upcomingbill",
        "billed",
      ];
      const params = new URLSearchParams(location.search);
      if (
        location.pathname.startsWith("/debitdetail") &&
        tabTypes.includes(params.get("type"))
      ) {
        foundIndex = profoption.findIndex((opt) => opt.title === "MY DEBIT");
      }
    }

    // Handle all /refundorderdtl/:id?status=xxx cases for MY REFUND
    if (foundIndex === -1) {
      const tabTypes = ["all", "processing", "cancelled", "done"];
      const params = new URLSearchParams(location.search);
      if (
        location.pathname.startsWith("/refundorderdtl") &&
        tabTypes.includes(params.get("status"))
      ) {
        foundIndex = profoption.findIndex((opt) => opt.title === "MY REFUND");
      }
    }

    if (foundIndex !== -1) {
      setOpenIndex(foundIndex);
    }
  }, [location.pathname, location.search, profoption]);

  const handleOpen = async (index) => {
    if (openIndex !== index) {
      setOpenIndex(index);

      if (profoption[index].options && profoption[index].options.length > 0) {
        navigate(profoption[index].options[0].path);
      }
    }
  };

  return (
    <div className="profilenav">
      <div className="profilenav-content">
        <div className="myprofile-container">
          <FallbackImg
            src={user?.profile_photo_url}
            alt="usercircle"
            width="50"
            height="50"
          />
          <div className="myprofile">
            <div className="username">
              <span className="truncate-name-long">{user?.name}</span>
            </div>
            <div className="email">{user?.email}</div>
          </div>
        </div>
        {/* <div className="myprofloyalty">
          <FallbackImg src={Exp7} alt="usercircle" width="15" height="15" />
          <Link to="/myloyalty">Platinum &gt;</Link>
        </div> */}
        {/* <Link to="/mycredit" className="myprofcredit">
          <div className="myprofcredit-container">
            <div>My Credit:</div>
            <div>RM {totalCredit ? formatCurrency(totalCredit) : "0.00"}</div>
          </div>
        </Link> */}

        {location.pathname === "/mypaymenthistory" && unsuccessfulTotal > 0 ? (
          <div
            className="myprofoverdue-container"
            style={{ flexDirection: "column", alignItems: "flex-start" }}
          >
            <div className="myprofoverdue-cancelled-label">
              Total Unsuccessful Amount:
            </div>
            <div className="myprofoverdue-cancelled-value">
              <div className="profnav-RM">RM</div>
              {formatCurrency(unsuccessfulTotal)}
            </div>
          </div>
        ) : (
          overdueTotal > 0 && (
            <div
              className="myprofoverdue"
              onClick={() => {
                if (!canViewInvoice) return;
                navigate("/mypaymentcart");
              }}
              style={{
                opacity: canViewInvoice ? 1 : 0.5,
                cursor: canViewInvoice ? "pointer" : "not-allowed",
              }}
              title={canViewInvoice ? "" : "No permission"}
            >
              <div className="myprofoverdue-container">
                <div>Overdue :</div>
                <div className="myprofoverdue-value">
                  <div className="profnav-RM">RM</div>
                  {formatCurrency(overdueTotal)}
                </div>
              </div>
            </div>
          )
        )}

        <div className="profilenav-dropdown">
          <ul>
            {profoption.map((profnav, index) => (
              <li key={index}>
                {profnav.path ? (
                  <div
                    className={`profnavitem${
                      location.pathname === profnav.path ? " active-title" : ""
                    }`}
                    onClick={() => {
                      if (profnav.disabled) return;
                      navigate(profnav.path);
                    }}
                    style={{
                      opacity: profnav.disabled ? 0.5 : 1,
                      cursor: profnav.disabled ? "not-allowed" : "pointer",
                    }}
                    title={profnav.disabled ? "No permission" : ""}
                  >
                    <strong>{profnav.title}</strong>
                  </div>
                ) : (
                  <div
                    className={`profnavitem${
                      openIndex === index ? " active-title" : ""
                    }`}
                    onClick={() => {
                      if (profnav.disabled) return;
                      if (profnav.title === "LOGOUT") {
                        setShowLogout(true);
                      } else {
                        handleOpen(index);
                      }
                    }}
                    style={{
                      opacity: profnav.disabled ? 0.5 : 1,
                      cursor: profnav.disabled ? "not-allowed" : "pointer",
                    }}
                    title={profnav.disabled ? "No permission" : ""}
                  >
                    <strong>{profnav.title}</strong>
                  </div>
                )}

                {profnav.options &&
                  profnav.options.length > 0 &&
                  openIndex === index && (
                    <ul className="subprofnavlist">
                      {profnav.options.map((opt, i) => {
                        const url = new URL(opt.path, window.location.origin);
                        const params = new URLSearchParams(location.search);

                        // Extract tab/type/status from menu option path
                        const optTab = opt.path.match(/tab=([^&]*)/)?.[1];
                        const optType = opt.path.match(/type=([^&]*)/)?.[1];
                        const optStatus = opt.path.match(/status=([^&]*)/)?.[1];

                        const isAllOrderActive =
                          opt.label === "All" &&
                          location.pathname.startsWith("/orderdetail") &&
                          params.get("type") === "all";
                        const isToPayOrderActive =
                          opt.label === "New Order" &&
                          location.pathname.startsWith("/orderdetail") &&
                          params.get("type") === "topay";
                        const isNewOrderActive =
                          opt.label === "New Order" &&
                          location.pathname.startsWith("/orderdetail") &&
                          params.get("type") === "neworder";
                        const isProcessingOrderActive =
                          opt.label === "Processing" &&
                          location.pathname.startsWith("/orderdetail") &&
                          params.get("type") === "processing";
                        const isShippingOrderActive =
                          opt.label === "Shipping" &&
                          location.pathname.startsWith("/orderdetail") &&
                          params.get("type") === "toship";
                        const isReceivedOrderActive =
                          opt.label === "Received" &&
                          location.pathname.startsWith("/orderdetail") &&
                          params.get("type") === "toreceive";
                        const isCancelledOrderActive =
                          opt.label === "Cancelled" &&
                          location.pathname.startsWith("/orderdetail") &&
                          params.get("type") === "cancelled";

                        const isAllRepairActive =
                          opt.label === "All" &&
                          location.pathname.startsWith("/repairdetail") &&
                          params.get("status") === "all";
                        const isNewRepairActive =
                          opt.label === "New" &&
                          location.pathname.startsWith("/repairdetail") &&
                          params.get("status") === "new";
                        const isCollectedRepairActive =
                          opt.label === "Collected" &&
                          location.pathname.startsWith("/repairdetail") &&
                          params.get("status") === "collected";
                        const isReparingRepairActive =
                          opt.label === "Repairing" &&
                          location.pathname.startsWith("/repairdetail") &&
                          params.get("status") === "repairing";
                        const isShippingRepairActive =
                          opt.label === "Shipping" &&
                          location.pathname.startsWith("/repairdetail") &&
                          params.get("status") === "shipping";
                        const isReceivedRepairActive =
                          opt.label === "Received" &&
                          location.pathname.startsWith("/repairdetail") &&
                          params.get("status") === "received";
                        const isRefundRepairActive =
                          opt.label === "Refund" &&
                          location.pathname.startsWith("/repairdetail") &&
                          params.get("status") === "refund";
                        const isCancelledRepairActive =
                          opt.label === "Cancelled" &&
                          location.pathname.startsWith("/repairdetail") &&
                          params.get("status") === "cancelled";

                        const isAllInvoiceActive =
                          opt.label === "All" &&
                          location.pathname.startsWith("/invoicedetail") &&
                          params.get("type") === "all";
                        const isOutstandingInvoiceActive =
                          opt.label === "Outstanding" &&
                          location.pathname.startsWith("/invoicedetail") &&
                          params.get("type") === "outstanding";
                        const isOverdueInvoiceActive =
                          opt.label === "Overdue" &&
                          location.pathname.startsWith("/invoicedetail") &&
                          params.get("type") === "overduebill";
                        const isDueInvoiceActive =
                          opt.label === "Due" &&
                          location.pathname.startsWith("/invoicedetail") &&
                          params.get("type") === "duebill";
                        const isUpcomingInvoiceActive =
                          opt.label === "Upcoming" &&
                          location.pathname.startsWith("/invoicedetail") &&
                          params.get("type") === "upcomingbill";
                        const isPaidInvoiceActive =
                          opt.label === "Paid" &&
                          location.pathname.startsWith("/invoicedetail") &&
                          params.get("type") === "billed";

                        const isAllPaymentActive =
                          (opt.label === "All" &&
                            location.pathname.startsWith("/transdtlpayment") &&
                            params.get("type") === "all") ||
                          (opt.label === "All" &&
                            location.pathname.startsWith("/orderdetail") &&
                            params.has("mph") &&
                            params.get("type") === "all");
                        const isToPayPaymentActive =
                          (opt.label === "To Pay" &&
                            location.pathname.startsWith("/transdtlpayment") &&
                            params.get("type") === "to_pay") ||
                          (opt.label === "To Pay" &&
                            location.pathname.startsWith("/orderdetail") &&
                            params.has("mph") &&
                            params.get("type") === "to_pay");
                        const isProcessingPaymentActive =
                          (opt.label === "Processing" &&
                            location.pathname.startsWith("/transdtlpayment") &&
                            params.get("type") === "processing") ||
                          (opt.label === "Processing" &&
                            location.pathname.startsWith("/orderdetail") &&
                            params.has("mph") &&
                            params.get("type") === "processing");
                        const isUnsuccessfulPaymentActive =
                          (opt.label === "Unsuccessful" &&
                            location.pathname.startsWith("/transdtlpayment") &&
                            params.get("type") === "unsuccessful") ||
                          (opt.label === "Unsuccessful" &&
                            location.pathname.startsWith("/orderdetail") &&
                            params.has("mph") &&
                            params.get("type") === "unsuccessful");
                        const isCancelledPaymentActive =
                          (opt.label === "Cancelled" &&
                            location.pathname.startsWith("/transdtlpayment") &&
                            params.get("type") === "cancelled") ||
                          (opt.label === "Cancelled" &&
                            location.pathname.startsWith("/orderdetail") &&
                            params.has("mph") &&
                            params.get("type") === "cancelled");
                        const isPaidPaymentActive =
                          (opt.label === "Paid" &&
                            location.pathname.startsWith("/transdtlpayment") &&
                            params.get("type") === "paid") ||
                          (opt.label === "Paid" &&
                            location.pathname.startsWith("/orderdetail") &&
                            params.has("mph") &&
                            params.get("type") === "paid");

                        const isAllCreditActive =
                          opt.label === "All" &&
                          location.pathname.startsWith("/creditdetail") &&
                          params.get("tab") === "all";
                        const isAppliedCreditActive =
                          opt.label === "Applied" &&
                          location.pathname.startsWith("/creditdetail") &&
                          params.get("tab") === "used";
                        const isUnappliedCreditActive =
                          opt.label === "Unapplied" &&
                          location.pathname.startsWith("/creditdetail") &&
                          params.get("tab") === "available";

                        const isAllDebitActive =
                          opt.label === "All" &&
                          location.pathname.startsWith("/debitdetail") &&
                          params.get("type") === "all";
                        const isOutstandingDebitActive =
                          opt.label === "Outstanding" &&
                          location.pathname.startsWith("/debitdetail") &&
                          params.get("type") === "outstanding";
                        const isOverdueDebitActive =
                          opt.label === "Overdue" &&
                          location.pathname.startsWith("/debitdetail") &&
                          params.get("type") === "overduebill";
                        const isDueDebitActive =
                          opt.label === "Due" &&
                          location.pathname.startsWith("/debitdetail") &&
                          params.get("type") === "duebill";
                        const isUpcomingDebitActive =
                          opt.label === "Upcoming" &&
                          location.pathname.startsWith("/debitdetail") &&
                          params.get("type") === "upcomingbill";
                        const isPaidDebitActive =
                          opt.label === "Paid" &&
                          location.pathname.startsWith("/debitdetail") &&
                          params.get("type") === "billed";

                        const isAllRefundActive =
                          opt.label === "All" &&
                          location.pathname.startsWith("/refundorderdtl") &&
                          params.get("status") === "all";
                        const isProcessingRefundActive =
                          opt.label === "Processing" &&
                          location.pathname.startsWith("/refundorderdtl") &&
                          params.get("status") === "processing";
                        const isCancelledRefundActive =
                          opt.label === "Cancelled" &&
                          location.pathname.startsWith("/refundorderdtl") &&
                          params.get("status") === "cancelled";
                        const isDoneRefundActive =
                          opt.label === "Done" &&
                          location.pathname.startsWith("/refundorderdtl") &&
                          params.get("status") === "done";

                        const isActive =
                          (url.pathname === location.pathname &&
                            url.search === location.search) ||
                          (url.pathname === location.pathname &&
                            params.get("tab") === optTab &&
                            params.get("type") === optType) ||
                          (url.pathname === location.pathname &&
                            params.get("status") === optStatus) ||
                          isAllOrderActive ||
                          isToPayOrderActive ||
                          isNewOrderActive ||
                          isProcessingOrderActive ||
                          isShippingOrderActive ||
                          isReceivedOrderActive ||
                          isCancelledOrderActive ||
                          isAllRepairActive ||
                          isNewRepairActive ||
                          isCollectedRepairActive ||
                          isReparingRepairActive ||
                          isShippingRepairActive ||
                          isReceivedRepairActive ||
                          isRefundRepairActive ||
                          isCancelledRepairActive ||
                          isAllInvoiceActive ||
                          isOutstandingInvoiceActive ||
                          isOverdueInvoiceActive ||
                          isDueInvoiceActive ||
                          isUpcomingInvoiceActive ||
                          isPaidInvoiceActive ||
                          isAllPaymentActive ||
                          isToPayPaymentActive ||
                          isProcessingPaymentActive ||
                          isUnsuccessfulPaymentActive ||
                          isCancelledPaymentActive ||
                          isPaidPaymentActive ||
                          isAllCreditActive ||
                          isAppliedCreditActive ||
                          isUnappliedCreditActive ||
                          isAllDebitActive ||
                          isOutstandingDebitActive ||
                          isOverdueDebitActive ||
                          isDueDebitActive ||
                          isUpcomingDebitActive ||
                          isPaidDebitActive ||
                          isAllRefundActive ||
                          isProcessingRefundActive ||
                          isCancelledRefundActive ||
                          isDoneRefundActive;
                        return (
                          <li
                            key={i}
                            className={`subprofnavitem${
                              isActive ? " active-option" : ""
                            }`}
                            style={{
                              opacity: opt.disabled ? 0.5 : 1,
                              cursor: opt.disabled ? "not-allowed" : "pointer",
                            }}
                            title={opt.disabled ? "No permission" : ""}
                            onClick={(e) => {
                              if (opt.disabled) {
                                e.preventDefault();
                                return;
                              }
                              navigate(opt.path);
                            }}
                          >
                            <span>{opt.label}</span>
                          </li>
                        );
                      })}
                    </ul>
                  )}
              </li>
            ))}
          </ul>
        </div>
        {showLogout && <LogoutNotif onClose={() => setShowLogout(false)} />}
      </div>
    </div>
  );
};

export default ProfileNav;
